import "./Bonus.scss";
import {MAX_LEVEL} from "../LevelBlock/LevelBlock";

const RADIUS = 62;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

// Кільцевий індикатор: скільки з максимальних +5% бонусу вже відкрито
const Bonus = ({user}) => {
    const bonus = user.personalBonus || 0;
    const share = Math.min(bonus / MAX_LEVEL, 1);
    const maxed = share >= 1;

    return (
        <div className="pb-gauge">
            <div className={`pb-gauge-ring ${maxed ? "is-max" : ""}`}>
                {/* корона — лише на максимальному рівні */}
                { maxed &&
                    <svg className="pb-crown" viewBox="0 0 32 22" width="68" height="47" aria-label="Максимальний рівень">
                        <path d="M4 18V6.5l6.5 5L16 3l5.5 8.5 6.5-5V18z" fill="#e6b54a" stroke="#e6b54a" strokeWidth="2.5" strokeLinejoin="round" />
                    </svg>
                }
                <svg viewBox="0 0 150 150" width="150" height="150" aria-hidden="true">
                    <defs>
                        <linearGradient id="pb-gauge-grad" x1="0" y1="0" x2="1" y2="1">
                            <stop offset="0" stopColor="#4046eb" />
                            <stop offset="1" stopColor="#1a8bff" />
                        </linearGradient>
                        <linearGradient id="pb-gauge-gold" x1="0" y1="0" x2="1" y2="1">
                            <stop offset="0" stopColor="#f5d27a" />
                            <stop offset="1" stopColor="#d99a2b" />
                        </linearGradient>
                    </defs>
                    <circle cx="75" cy="75" r={RADIUS} className="pb-gauge-track" />
                    <circle
                        cx="75"
                        cy="75"
                        r={RADIUS}
                        className="pb-gauge-arc"
                        stroke={maxed ? "url(#pb-gauge-gold)" : "url(#pb-gauge-grad)"}
                        strokeDasharray={`${CIRCUMFERENCE * share} ${CIRCUMFERENCE}`}
                        transform="rotate(-90 75 75)"
                    />
                </svg>
                <div className="pb-gauge-value">+{bonus}%</div>
            </div>
            <div className="pb-gauge-caption">особистий бонус</div>
            <div className="pb-gauge-max">максимум +{MAX_LEVEL}%</div>
        </div>
    );
};

export default Bonus;
